module.exports = __webpack_public_path__ + "img/rankinglist_ranking3.4592c520.png";